import { useRouter } from "next/router";

import useStorefrontCollections from "../hooks/useStorefrontCollections";
import { collectionPath } from "../lib/collectionUrls";
import LinkItem from "./LinkItem";

const SideNavDrawer = ({ isOpen, toggleDrawer }) => {
  const router = useRouter();

  const {
    data: collectionsData,
    isLoading: isCollectionsLoading,
    error: collectionsError,
  } = useStorefrontCollections();

  const collections = collectionsData?.collections || [];

  if (collectionsError) return <div>Error loading collections</div>;

  const onClickItem = (path) => {
    router.push(path);
    toggleDrawer();
  };

  return (
    <aside
      className={`fixed left-1/2 z-40 w-full max-w-app overflow-y-auto bg-background pb-[env(safe-area-inset-bottom,0px)] font-montserrat transition-transform duration-500 ease-in-out ${
        isOpen ? "-translate-x-1/2" : "pointer-events-none -translate-x-[calc(100%+50vw)]"
      }`}
      style={{
        top: "var(--store-chrome-bottom, 60px)",
        height: "calc(100dvh - var(--store-chrome-bottom, 60px))",
      }}
    >
      <nav className="mt-4">
        <ul className="ml-0 flex w-full flex-col gap-y-2">
          <li className="w-full" onClick={() => toggleDrawer()}>
            <LinkItem
              href="/collections/all"
              label="Shop All"
              className="block w-full px-5 text-[20px] font-medium text-checkoutText"
            />
          </li>

          {!isCollectionsLoading &&
            collections.map((collection) => (
              <li key={collection.id} className="w-full">
                <a
                  className="block w-full cursor-pointer break-words px-5 text-[20px] font-medium text-checkoutText"
                  onClick={() => onClickItem(collectionPath(collection))}
                >
                  {collection.title}
                </a>
              </li>
            ))}
        </ul>
      </nav>
    </aside>
  );
};

export default SideNavDrawer;
